export {
  createCollatorItemFilter,
  createSingleSelectionCollatorFilter,
  type FilterItemToString,
} from '../../../internals/collatorItemFilter';

/**
 * Derives the default id assigned to `Combobox.Popup` when the input is rendered inside it.
 * Shared by the popup (which applies it) and the trigger (which references it via `aria-controls`)
 * so the convention only lives in one place.
 */
export function getComboboxPopupId(rootId: string | null | undefined) {
  return rootId == null ? undefined : `${rootId}-popup`;
}
